/*
forgot-password-popup-ctrl.js

-GE CONFIDENTIAL-
Type: Source Code

Copyright (c) 2021, GE Healthcare Co.
All Rights Reserved

This unpublished material is proprietary to GE Healthcare. The methods and
techniques described herein are considered trade secrets and/or
confidential. Reproduction or distribution, in whole or in part, is
forbidden except by express written permission of GE Healthcare.
*/
define('login/modules/forgot-password-popup/controllers/forgot-password-popup-ctrl',['angular', 'ui-bootstrap', 'geControlGroup', 'inputPatterns', 'validateUsernameApi',
    '../services/forgot-password-popup-i18n', '../directives/ge-captcha/ge-captcha',
    'geXss'], function () {

// Module Dependencies
    var dependencies = [
        'ui.bootstrap',
        // vendor
        // forgot password module
        'ForgotPasswordPopUp.Services.i18n',
        // shared modules
        'Directives.GeControlGroup',
        'Directives.GeCaptcha',
        'Services.InputPatterns',
        'Services.ValidateUsernameApi',
        'Directives.GeXss'
    ];

// Module Definition
    var mod = angular.module('ForgotPasswordPopUp.Controllers.ForgotPasswordPopUpCtrl', dependencies);

    /**
     * @name ForgotPasswordPopUpCtrl
     * @type controller
     *
     * @description
     * Controller for the 'Forgot Password' pop-up.
     */
    mod.controller('ForgotPasswordPopUpCtrl', ['$rootScope', '$scope', '$state', '$timeout', 'ForgotPasswordPopUp.i18n', 'inputPatterns', 'validateUsernameApi',
        function ($rootScope, $scope, $state, $timeout, i18n, inputPatterns, validateUsernameApi) {
            // Collection of localized messages
            $scope.msg = i18n.getMessages();

            $scope.isPopUpVisible = true;

            // Selects which 'ng-switch' view to display within the pop-up
            $scope.activeView = 'form';

            // Container for all form data
            $scope.formData = {};

// flag for selective options of radio buttons
            $scope.showSlectiveOptions = false;

            $scope.closePopup = function () {
                $scope.isPopUpVisible = false;
                $rootScope.isPopUpVisible = false;
            };

            // Pattern matching for input values
            $scope.inputPatterns = inputPatterns;

            // Get the current locale
            $scope.isLocaleJP = window.Messages('inbox.localeCode').toLowerCase() === "ja";

            $scope.loadForm = function () {
                $rootScope.isPopUpVisible = true;
                validateUsernameApi.isCaptchaEnabled().then(function (response) {
                    $rootScope.isCaptchaEnabled = JSON.parse(response).IS_CAPTCHA_ENABLED === "true" ? true : false;
                });
                $state.go('app.login.forgotPassword', {}, {reload: true});
            };
            $scope.warnSSOUser = false;
            $scope.fetchOrgDetails = function () {
                $scope.formData.resetPasswordMethods = $scope.msg.resetPasswordWithQuestions;
                if ($scope.forgotPasswordForm.email.$valid === true) {
                    validateUsernameApi.fetchUserOrgDetails($scope.formData.email).then(
                        function (response) {
                            if (response.statusCode === "200" && response.result[0] === true) {
                                $scope.showSlectiveOptions = true;
                            } else if (response.statusCode === "202" && response.result[0] === true) {
                                $scope.showSlectiveOptions = false;
                                $scope.warnSSOUser = true;
                            } else {
                                $scope.showSlectiveOptions = false;
                            }
                        },
                        function () {
                            // Show the error message
                            $scope.showSlectiveOptions = false;

                        });
                }
            };

            // Submission of the page to validate user existence including Captcha validation
            $scope.submit = function () {
                if ($scope.warnSSOUser) {
                    $scope.formData.captcha = '';
                    $scope.formData.guid = '';
                    $scope.activeView = 'confirmation';
                    return;
                }
                // Make sure the form is valid before submitting
                if ($scope.forgotPasswordForm.$valid === true) {

                    var isSMSVerified = $scope.formData.resetPasswordMethods === $scope.msg.resetPasswordWithSMS ? true : false;
                    if ($rootScope.isCaptchaEnabled) {

                        validateUsernameApi.validateCaptcha($scope.formData.captcha, $scope.formData.guid).then(
                            function () {
                                // Open the confirmation window
                                $scope.activeView = 'confirmation';

                                // Verifys email
                                validateUsernameApi.validateUsername($scope.formData.email, $scope.formData.captcha, $scope.formData.guid, isSMSVerified).then(
                                    function () {
                                        $scope.formData.email = '';
                                        $scope.formData.captcha = '';
                                    },
                                    function () {
                                        console.log("Error occured user name validating");
                                    });
                            },
                            function (response) {
                                // Show the error message
                                $scope.errorMsg = response;
                                // Clear the captcha input
                                $scope.formData.captcha = '';
                                // Load a new captcha image
                                $scope.reloadCaptcha = !($scope.reloadCaptcha);
                            });

                    } else {
                        $scope.formData.captcha = '';
                        $scope.formData.guid = '';

                        $scope.activeView = 'confirmation';

                        // Verify email
                        validateUsernameApi.validateUsername($scope.formData.email, $scope.formData.captcha, $scope.formData.guid, isSMSVerified).then(
                            function () {
                                $scope.formData.email = '';
                                $scope.formData.captcha = '';
                            },
                            function () {
                                console.log("Error occured user name validating");
                            });
                    }
                }
            };

        }]);

    mod.directive('ngEnter', function () {
        return function (scope, elements, attrs) {
            elements.bind('keydown keypress', function (event) {
                if (event.which === 13) {
                    scope.$apply(function () {
                        scope.$eval(attrs.ngEnter);
                    });
                    event.preventDefault();
                }
            });
        };
    });
});

